import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    codigo: '',
    marcaModelo: '',
    numeroIMEI: '',
    numero: '',
    rubroId: 0,
    rubro: null,
    rubroNombre: null,
    tieneCargador: false,
    cotizacion: 0,
    pjeAmortizacion: 0,
    enRevision: false,
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_CELULAR'(state, celularId) {
        state.id = celularId;
        state.codigo = '';
        state.marcaModelo = '';
        state.numeroIMEI = '';
        state.numero = '';
        state.rubroId = 0;
        state.rubro = null;
        state.rubroNombre = null;
        state.tieneCargador = false;
        state.cotizacion = 0;
        state.pjeAmortizacion = 0;
        state.enRevision = false;
        state.rowVersion = null;
    },
    'SET_CELULAR'(state, celular) {
        state.codigo = celular.codigo.toUpperCase().trim();
        state.marcaModelo = celular.marcaModelo.toUpperCase().trim();
        state.numeroIMEI = celular.numeroIMEI.trim();
        state.numero = celular.numero.trim();
        state.rubroId = celular.rubroId;
        state.rubro = celular.rubro;
        state.rubroNombre = celular.rubro? celular.rubro.nombre.trim() : null;
        state.tieneCargador = (/true/i).test(celular.tieneCargador);
        state.cotizacion = parseFloat(celular.cotizacion);
        state.pjeAmortizacion = parseFloat(celular.pjeAmortizacion);
        state.enRevision = (/true/i).test(celular.enRevision);
        state.rowVersion = celular.rowVersion;
    },
    'SET_RUBRO'(state, rubro) {
        state.rubro = rubro;
        if (rubro) {
            state.rubroId = rubro.id? rubro.id : 0;
            state.rubroNombre = rubro.nombre? rubro.nombre.trim() : null;
        } else {
            state.rubroId = 0;
            state.rubroNombre = null;
        }
    },
    'SET_CELULAR_ID' (state, params) {
        state.id = params.id;
        state.rowVersion = params.rowVersion;
    },
};

const getters = {
    getField,

    celular(state) {
        return {
            id: state.id,
            codigo: state.codigo.toUpperCase().trim(),
            marcaModelo: state.marcaModelo.toUpperCase().trim(),
            numeroIMEI: state.numeroIMEI.trim(),
            numero: state.numero.trim(),
            tieneCargador: state.tieneCargador,
            rubroId: state.rubroId,
            enRevision: state.enRevision,
            rowVersion: state.rowVersion,
        }
    }
};

const actions = {
    inicializar ( { commit }, celularId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CELULAR', celularId);
            
            if (celularId != 0){
                apiAxios.get(`bienes/celulares/${celularId}/abm` ) 
                    .then(res => {
                        commit('SET_CELULAR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },    
    save ( {commit} ) {
        return new Promise((resolve, reject) => {
            let celular= {
                codigo: state.codigo.toUpperCase().trim(),
                marcaModelo: state.marcaModelo.toUpperCase().trim(),
                numeroIMEI: state.numeroIMEI.trim(),
                numero: state.numero.trim(),
                rubroId: parseInt(state.rubroId),
                tieneCargador: (/true/i).test(state.tieneCargador),
                cotizacion: parseFloat(state.cotizacion),
                pjeAmortizacion: parseFloat(state.pjeAmortizacion),
                enRevision: (/true/i).test(state.enRevision),
            }
            let url = 'bienes/celulares';
            
            if (state.id != 0) {
                url += '/' + state.id;
                celular.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, celular)
                .then((res) => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_CELULAR_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setRubro: ({commit}, rubro) => {
        commit('SET_RUBRO', rubro);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}